import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ADMIN_PATHS, adminPath } from '../../constants/adminPaths';
import { adminListDemos } from '../../api/demosApi';

const RecentDemos = () => {
  const [demos, setDemos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDemos = async () => {
      try {
        setLoading(true);
        const data = await adminListDemos();
        const normalized = data
          .map((d) => ({
            ...d,
            dateTime: d.dateTime ? new Date(d.dateTime) : null,
          }))
          .sort((a, b) => {
            const aTime = a.dateTime ? a.dateTime.getTime() : 0;
            const bTime = b.dateTime ? b.dateTime.getTime() : 0;
            return bTime - aTime;
          })
          .slice(0, 3);

        setDemos(normalized);
        setError(null);
      } catch (err) {
        setError('Failed to load recent demos');
      } finally {
        setLoading(false);
      }
    };

    fetchDemos();
  }, []);

  const formatDateTime = (date) => {
    if (!date) return '';
    try {
      return date.toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
    } catch {
      return '';
    }
  };

  return (
    <div className="dash-card__body">
      <div className="dash-card__header">
        <h3 className="dash-card__title">Recent Demos</h3>
        <RouterLink to={adminPath(ADMIN_PATHS.DEMOS)} className="dash-card__link">View All</RouterLink>
      </div>

      {loading ? (
        <div>
          {[0, 1, 2].map((i) => (
            <div key={i} className="dash-row dash-row--skeleton">
              <div className="dash-row__title skeleton" />
              <div className="dash-row__meta skeleton" />
            </div>
          ))}
        </div>
      ) : error ? (
        <div className="dash-card__empty">{error}</div>
      ) : demos.length === 0 ? (
        <div className="dash-card__empty">No recent demos.</div>
      ) : (
        <div>
          {demos.map((demo, idx) => (
            <div key={demo.id || idx} className="dash-row">
              <div className="dash-row__left">
                <div className="dash-row__title">{demo.name || 'N/A'}</div>
                <div className="dash-row__subtitle">{demo.companyName || demo.email || ''}</div>
              </div>
              <div className="dash-row__right">
                <div className="dash-row__meta">{formatDateTime(demo.dateTime)}</div>
                {demo.status && (
                  <span className={`dash-badge dash-badge--${(demo.status || 'default').toLowerCase()}`}>
                    {demo.status}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default RecentDemos;
